import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../contexts/ProjectContext';
import { dashboardService } from '../../services/dashboard';
import Toggle from './components/Toggle';

export default function CreateProjectModal() {
  const navigate = useNavigate();
  const { reloadProjects, setSelectedProject } = useProject();
  const [name, setName] = useState('');
  const [routingEnabled, setRoutingEnabled] = useState(true);
  const [cacheEnabled, setCacheEnabled] = useState(true);
  const [evalEnabled, setEvalEnabled] = useState(false);
  const [saving, setSaving] = useState(false);

  const close = () => navigate('/settings/projects/');

  const submit = () => {
    if (!name.trim()) return;
    setSaving(true);
    dashboardService.createProject(
      {
        name: name.trim(),
        routing_enabled: routingEnabled,
        cache_enabled: cacheEnabled,
        eval_enabled: evalEnabled,
      },
      (res) => {
        if (res.data?.hash) setSelectedProject(res.data.hash);
        reloadProjects();
        close();
      },
      () => setSaving(false),
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl bg-theme-main border border-theme-secondary p-6 shadow-lg">
        <h2 className="text-lg font-medium mb-4">Add project</h2>
        <label className="block text-sm mb-1 opacity-70">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="New project name"
          autoFocus
          className="w-full rounded-lg border border-theme-secondary bg-theme-main px-3 py-2 text-sm mb-5"
        />

        <div className="space-y-3 mb-6">
          <div className="flex items-center justify-between gap-4 rounded-xl border border-theme-secondary p-3">
            <div>
              <div className="text-sm font-medium">Routing</div>
              <p className="text-xs opacity-60 mt-0.5">Route traffic to open-source models</p>
            </div>
            <Toggle checked={routingEnabled} onChange={setRoutingEnabled} label="Routing" />
          </div>
          <div className="flex items-center justify-between gap-4 rounded-xl border border-theme-secondary p-3">
            <div>
              <div className="text-sm font-medium">Cache</div>
              <p className="text-xs opacity-60 mt-0.5">Store routed payloads for faster repeats</p>
            </div>
            <Toggle checked={cacheEnabled} onChange={setCacheEnabled} label="Cache" />
          </div>
          <div className="flex items-center justify-between gap-4 rounded-xl border border-theme-secondary p-3">
            <div>
              <div className="text-sm font-medium">Shadow evals</div>
              <p className="text-xs opacity-60 mt-0.5">Sample traffic and score model quality</p>
            </div>
            <Toggle checked={evalEnabled} onChange={setEvalEnabled} label="Shadow evals" />
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button type="button" onClick={close} className="px-4 py-2 rounded-lg border border-theme-secondary text-sm">
            Cancel
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={saving || !name.trim()}
            className="px-4 py-2 rounded-lg bg-theme-primary text-theme-button text-sm font-medium disabled:opacity-40"
          >
            Add project
          </button>
        </div>
      </div>
    </div>
  );
}
